var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"serviceRankingList-rules"}},[_c('img',{attrs:{"src":`https://static.beautyfarm.com.cn/beauty_image/20251226/rule${_vm.$route.query.currentJobTab}.png`,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }